import { render, staticRenderFns } from "./Capacity.vue?vue&type=template&id=143f35e2&"
import script from "./Capacity.vue?vue&type=script&lang=js&"
export * from "./Capacity.vue?vue&type=script&lang=js&"
import style0 from "./Capacity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports